<template>
  <base-drawer
    :open="open"
    :close="close"
    @onClose="onClose"
    :title="`Configurar domínio ${getTitle()}`"
  >
    <base-card>
      <div class="d-flex justify-between align-center mb_20">
        <base-label text="Domínio que está sendo configurado" class="mb_0" />
      </div>

      <div class="url-2">
        <p>{{ urlDomain }}</p>
      </div>

      <base-card class="mt_15">
        <p class="copy-code">Copie os códigos abaixo</p>
        <p class="link-instructions">
          Caso ainda não tenha visto,
          <a target="_blank">leia as instruções</a>
        </p>
        <div class="hairline" />
        <p class="url-config">URL Configuração 1</p>

        <div class="input-copy">
          <base-input v-model="urlConfiguration1" />
          <div class="copy">
            <i
              v-if="!copyUrl1"
              class="fal fa-copy"
              @click="copyToClipboard(urlConfiguration1, 'config-1')"
              title="Copiar"
            />
            <base-badge
              v-else
              type="success"
              name="Copiado"
              :absolute="false"
            />
          </div>
        </div>
      </base-card>
    </base-card>

    <template slot="footer">
      <base-button class="w-100" text="Fechar" @click="closeDrawer()" />
    </template>
  </base-drawer>
</template>

<script>
/* eslint-disable import/no-unresolved */
import BaseTitle from '@/components/Title';
import BaseEmpty from '@/components/Empty';
import BaseBadge from '@/components/Badge';
import BaseButton from '@/components/Button';
import BaseInput from '@/components/Input';
import BaseAdd from '@/components/Add';
import BaseDrawer from '@/components/Drawer';
import BaseLabel from '@/components/Label';
import BaseCard from '@/components/Card';
import BaseSteps from '@/components/Steps';
import BaseMessage from '@/components/MultiplesMessages';

const components = {
  BaseTitle,
  BaseEmpty,
  BaseBadge,
  BaseButton,
  BaseInput,
  BaseAdd,
  BaseDrawer,
  BaseLabel,
  BaseCard,
  BaseSteps,
  BaseMessage,
};

export default {
  components,
  props: {
    open: { type: Boolean, default: false },
    close: { type: Boolean, default: false },
    urlDomain: { type: String },
    hash: { type: String },
  },
  data() {
    return {
      copyUrl1: false,
    };
  },
  methods: {
    getTitle() {
      switch (this.step) {
        case 1:
          return '';
        case 2:
          return '- Instruções';
        case 3:
          return '- URL';
        default:
          return '';
      }
    },
    closeDrawer() {
      this.$emit('cancel');
    }
  },
  computed: {
    urlConfiguration1() {
      return `${this.$props.urlDomain} CNAME ${process.env.VUE_APP_FRONT_DNS_ADDRESS}`
    }
  }
};
</script>

<style scoped>
.grid {
  display: grid;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.grid > div {
  margin-bottom: 0;
}
.grid > .add-box {
  height: 180px;
}
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 15px;
  margin-bottom: 25px;
  border-bottom: 1px solid #99999926;
}
.status {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: flex-start;
}
.input-copy {
  position: relative;
}
.input-copy .copy {
  position: absolute;
  bottom: 6px;
  right: 15px;
  cursor: pointer;
  height: 36px;
  display: flex;
  align-items: center;
}
.input-copy .copy i {
  color: var(--icon-inactive);
  font-size: 17px;
}
.copy-code {
  color: var(--label-secondary);
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 10px;
  text-align: center;
  font-weight: bold;
}
.link-instructions {
  color: #aaaaab80;
  font-size: 12px;
  line-height: 15px;
  left: 15px;
  text-align: center;
}
.link-instructions a {
  color: #aaaaab80;
  font-weight: 900;
  border-bottom: 1px solid transparent;
  padding-bottom: 2px;
  text-decoration: none;
}
.link-instructions a:hover {
  color: var(--label-secondary);
  border-color: var(--label-secondary);
}
.url-config {
  color: #aaaaabbf;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 5px;
  text-align: center;
  font-weight: bold;
}
.timer {
  background: #45484d80;
  border-radius: 5px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
}
.timer p {
  color: var(--label-primary);
  font-size: 12px;
  line-height: 15px;
  font-weight: bold;
  margin-left: 10px;
}
.timer i {
  font-size: 14px;
  color: var(--icon-inactive);
}
.status p {
  font-size: 14px;
  color: #cccccc;
  margin-top: 15px;
}
.buttons {
  display: flex;
}
.buttons button:not(:last-child) {
  margin-right: 15px;
}
.url-1,
.url-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  min-height: 45px;
  border-radius: 5px;
}
.url-1 {
  background: transparent;
  border: 1px solid #515159;
}
.url-2 {
  background: var(--box-up);
}
.url-1 p,
.url-2 p {
  color: var(--label-primary);
  font-size: 12px;
}
.url-1 i,
.url-2 i {
  color: var(--icon-inactive);
  font-size: 17px;
  cursor: pointer;
}

.hairline {
  margin: 30px auto;
  border-top: 1px solid #ffffff17;
  width: 100%;
}

.read-instructions {
  padding: 30px 20px 20px;
  background: #3f4145;
  border: 2px dashed #ffffff17;
}

.read-instructions p.title {
  color: var(--label-secondary);
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 20px;
  font-weight: bold;
  text-align: center;
}

.read-instructions p.description {
  font-size: 14px;
  color: var(--label-primary);
  line-height: 22px;
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;
}

.read-instructions p.description span {
  color: var(--default);
  font-weight: 900;
}

@media screen and (max-width: 991px) {
  .grid {
    grid-template-columns: repeat(1, 1fr);
  }
  .status p {
    font-size: 10px;
  }
  .grid > .add-box {
    height: auto;
  }
}
</style>
